var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofttrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 512",
    style: {
      enableBackground: "new 0 0 384 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#68995D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 199.2,
    cy: 178.5,
    rx: 146.7,
    ry: 140.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.8,68.1l-57.7,63.5c-1.5,1.6-2.3,3.8-2.3,6c0,5,4,9,9,9h9.7L116.9,175c-1.6,1.6-2.6,3.9-2.6,6.2 c0,4.9,3.9,8.8,8.8,8.8h13l-29,34.7c-1.4,1.6-2.1,3.7-2.1,5.8c0,5,4.1,9.1,9.1,9.1h65.4v12.4c0,6.9,5.5,12.4,12.4,12.4 s12.4-5.5,12.4-12.4v-12.4h65.4c5,0,9.1-4.1,9.1-9.1c0-2.1-0.7-4.2-2.1-5.8l-29-34.7h13c4.9,0,8.8-3.9,8.8-8.8 c0-2.3-0.9-4.6-2.6-6.2l-28.5-28.5h9.7c4.9,0,9-4,9-9c0-2.2-0.8-4.4-2.3-6l-57.7-63.5c-1.3-1.5-3.2-2.3-5.2-2.3 S188.1,66.6,186.8,68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192,512c0,0,192-208,192-320C384,86,298,0,192,0S0,86,0,192C0,304,192,512,192,512z M190.1,45.6 c71.5,0,129.4,57.9,129.4,129.4s-57.9,129.4-129.4,129.4S60.7,246.4,60.7,175S118.6,45.6,190.1,45.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofttrail);
export default __webpack_public_path__ + "static/media/softtrail.46edc765bb001db8ea2d4ca3fda245fe.svg";
export { ForwardRef as ReactComponent };